<template>
  <div>
    <v-data-table
      dense
      :headers="headers"
      :items="bookings"
      item-key="id"
      class="elevation-1"
    >
      <template v-slot:body="{ bookings }">
        <tbody>
          <router-link
            tag="tr"
            v-for="item in bookingsPlaced"
            :key="item.name"
            :to="'/booking/' + item.id"
          >
            <td>
              <router-link :to="'/profile/' + item.lenderID">
                {{ item.lenderName }}
              </router-link>
            </td>
            <td>{{ item.status }}</td>
            <td>{{ item.startDate }}</td>
            <td>{{ item.endDate }}</td>
            <td>{{ item.itemName }}</td>
            <td>{{ item.total }}</td>
          </router-link>
        </tbody>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: "StrappBookingsReceivedTable",

  data() {
    return {
      bookings: [],
      headers: [
        { text: "Owner", value: "lenderName", align: "left" },
        { text: "Status", value: "status", align: "left" },
        { text: "Start Date", value: "startDate", align: "left" },
        { text: "End Date", value: "endDate", align: "left" },
        { text: "Item", value: "itemName", align: "left" },
        { text: "Total(R)", value: "total", align: "left" },
      ],
    };
  },

  props: {
    bookingsPlaced: {
      type: Array,
      required: true,
    },
  },

  // created() {
  //   console.log("BookingsPlacedTable.vue mounted", this.bookingsReceived);
  //   console.log("BookingsPlacedTable.vue mounted", this.bookings);
  //   this.bookings = this.bookings;
  //   console.log("BookingsPlacedTable.vue mounted", this.bookings);
  // },

  methods: {},
};
</script>

<style lang="scss" scoped></style>
